import script from "./CRMStatusGroupCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMStatusGroupCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__